import { httpsCallable } from "firebase/functions";

import { cloudFunctions } from "./getFunctions";
import {
  CloudFunctionResponse,
  CallablesGeneral,
  ObtenerUltimoRegistroTurno as ObtenerUltimoRegistroTurnoParams,
  RegistroTurno
} from "@fixeduy/restaurantestypes";

export interface ObtenerUltimoRegistroTurnoResponse extends CloudFunctionResponse {
  adicionalData?: { registro: RegistroTurno | null };
}

const obtenerUltimoRegistroTurno = async (
  data: ObtenerUltimoRegistroTurnoParams
): Promise<RegistroTurno | null> => {
  const payload = { func: "obtenerUltimoRegistroTurno" as const, params: data };
  const run = httpsCallable<
    CallablesGeneral,
    ObtenerUltimoRegistroTurnoResponse
  >(cloudFunctions, "callablesGenerales");
  const result = await run(payload);
  const out = result.data as ObtenerUltimoRegistroTurnoResponse;
  if (!out?.exito) {
    throw new Error(out?.errorMsg ?? "Error al obtener último registro");
  }
  return out.adicionalData?.registro ?? null;
};

export { obtenerUltimoRegistroTurno };
